import { forwardRef } from 'react';
import styled from 'styled-components';
import { useIsMobile } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { noop } from 'es-toolkit';
import { Button } from './action-elements/button';
import type { FormProps } from './action-elements/form';
import { Form } from './action-elements/form';
import { Link } from './action-elements/link';

export const ActionElement = forwardRef<HTMLDivElement, FormProps>(
  function ActionElement({ onFormSubmit }, forwardingRef) {
    const { actionElement, actionElementMobile } = useSettings();

    const isMobile = useIsMobile();

    if (
      actionElement === 'none' ||
      !actionElement ||
      (isMobile && !actionElementMobile)
    )
      return null;

    const Element = {
      button: Button,
      link: Link,
      form: Form
    }[actionElement];

    return (
      <WithShrink>
        <Element
          ref={actionElement === 'form' ? forwardingRef : null}
          onFormSubmit={actionElement === 'form' ? onFormSubmit : noop}
        />
      </WithShrink>
    );
  }
);

const WithShrink = styled.div`
  flex-shrink: 0;
  max-width: 100%;
`;
